'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useParams } from 'next/navigation'

type PolygonCardProps = {
    data: IFederation | ICompetition
    dataType: 'competition' | 'federation'
}

const PolygonCard = ({ data, dataType }: PolygonCardProps) => {
    const params = useParams()
    const lang = params.lang

    // Determine the href based on dataType
    const href =
        dataType === 'competition'
            ? `/${lang}/competition/${data.id}/table`
            : `/${lang}/federation/${data.id}/competitions`

    return (
        <Link
            href={href}
            className='group polygon_card bg-accent-foreground/10 md:rounded-bl-md md:rounded-tr-md rounded-bl-sm rounded-tr-sm grid gap-2 md:gap-4 font-manrope object-contain w-full
       overflow-hidden'
        >
            <div>
                <div className='relative grid h-32 place-content-center overflow-hidden rounded-tl-md bg-gradient-to-br from-white/[0.08] to-transparent p-3 md:h-52 md:p-5 extra_large:h-80'>
                    {data?.logo ? (
                        <Image
                            src={data?.logo}
                            alt={data.name || 'Competition'}
                            fill
                            className='object-contain p-3 transition-transform duration-300 group-hover:scale-105 md:p-5'
                            sizes="(max-width: 768px) 100vw, 33vw"
                        />
                    ) : (
                        <p className='text-center text-4xl extra_large:!text-6xl font-bold'>
                            {data.name.charAt(0).toUpperCase()}
                        </p>
                    )}
                </div>
            </div>

            <div className='grid gap-2 px-2 pb-2 md:px-4 md:pb-4 extra_large:pb-6 extra_large:px-6'>
                <div className='flex items-center justify-between w-full gap-2'>
                    <div className='text-sm md:text-lg font-bold flex-1 min-w-0 w-px overflow-hidden'>
                        <div className='!truncate'>{data.name || 'Tournament Name'}</div>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default PolygonCard
